import { render, staticRenderFns } from "./videodetail.vue?vue&type=template&id=9c5d2362&scoped=true"
import script from "./videodetail.vue?vue&type=script&lang=js"
export * from "./videodetail.vue?vue&type=script&lang=js"
import style0 from "./videodetail.vue?vue&type=style&index=0&id=9c5d2362&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5d2362",
  null
  
)

export default component.exports